/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AgentMessageRefusalAgent model module.
 * @module model/AgentMessageRefusalAgent
 * @version 1.0.0
 */
class AgentMessageRefusalAgent {
    /**
     * Constructs a new <code>AgentMessageRefusalAgent</code>.
     * 退会済みのプランナーも返す（名前の表示用）
     * @alias module:model/AgentMessageRefusalAgent
     */
    constructor() { 
        
        AgentMessageRefusalAgent.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AgentMessageRefusalAgent</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AgentMessageRefusalAgent} obj Optional instance to populate.
     * @return {module:model/AgentMessageRefusalAgent} The populated <code>AgentMessageRefusalAgent</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AgentMessageRefusalAgent();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('company_id')) {
                obj['company_id'] = ApiClient.convertToType(data['company_id'], 'Number');
            }
            if (data.hasOwnProperty('family_name')) {
                obj['family_name'] = ApiClient.convertToType(data['family_name'], 'String');
            }
            if (data.hasOwnProperty('first_name')) {
                obj['first_name'] = ApiClient.convertToType(data['first_name'], 'String');
            }
            if (data.hasOwnProperty('company_name')) {
                obj['company_name'] = ApiClient.convertToType(data['company_name'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AgentMessageRefusalAgent</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AgentMessageRefusalAgent</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['family_name'] && !(typeof data['family_name'] === 'string' || data['family_name'] instanceof String)) {
            throw new Error("Expected the field `family_name` to be a primitive type in the JSON string but got " + data['family_name']);
        }
        // ensure the json data is a string
        if (data['first_name'] && !(typeof data['first_name'] === 'string' || data['first_name'] instanceof String)) {
            throw new Error("Expected the field `first_name` to be a primitive type in the JSON string but got " + data['first_name']);
        }
        // ensure the json data is a string
        if (data['company_name'] && !(typeof data['company_name'] === 'string' || data['company_name'] instanceof String)) {
            throw new Error("Expected the field `company_name` to be a primitive type in the JSON string but got " + data['company_name']);
        }

        return true;
    }


}



/**
 * @member {Number} id
 */
AgentMessageRefusalAgent.prototype['id'] = undefined;

/**
 * @member {Number} company_id
 */
AgentMessageRefusalAgent.prototype['company_id'] = undefined;

/**
 * @member {String} family_name
 */
AgentMessageRefusalAgent.prototype['family_name'] = undefined;

/**
 * @member {String} first_name
 */
AgentMessageRefusalAgent.prototype['first_name'] = undefined;

/**
 * @member {String} company_name
 */
AgentMessageRefusalAgent.prototype['company_name'] = undefined;






export default AgentMessageRefusalAgent;

